// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--main-color:#0097ce}*{padding:0;margin:0;box-sizing:border-box;word-break:break-word}*,body{font-family:Roboto,sans-serif}button{cursor:pointer;border:none;background:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
